import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: 'console/app-js/shared/components/button/button.component.html'
})
export class ButtonComponent implements OnInit {
  @Input() type: String = 'primary';
  @Input() label: String;
  @Input() fullWidth: Boolean = false;
  @Input() disabled: Boolean = false;
  @Input() buttonType: String = 'submit';
  @Output() clicked = new EventEmitter();

  className: String = '';
  isPrimary: Boolean = true;

  ngOnInit() {
    if (this.type !== 'primary') {
      this.isPrimary = false;
    }

    if (this.type === 'secondary' || this.type === 'tertiary') {
      this.className = this.type;
    }
  }

  handleClick = ($event: any) => {
    this.clicked.emit($event);
  };
}
